import { useEffect, useRef, useState } from "react";
import { apiClient } from "../../lib/api";

// Simple two-tone ring made with WebAudio (no audio asset needed).
function startRingtone() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return () => {};
  const ctx = new Ctx();
  let stopped = false;
  const burst = () => {
    if (stopped) return;
    [0, 0.45].forEach((offset) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.frequency.value = 480; o.connect(g); g.connect(ctx.destination);
      g.gain.setValueAtTime(0.18, ctx.currentTime + offset);
      g.gain.setValueAtTime(0, ctx.currentTime + offset + 0.4);
      o.start(ctx.currentTime + offset); o.stop(ctx.currentTime + offset + 0.4);
    });
  };
  burst();
  const t = setInterval(burst, 3000);
  return () => { stopped = true; clearInterval(t); ctx.close().catch(() => {}); };
}

// Polls for calls ringing this user; rings + desktop-notifies on new ones.
export function useIncomingCalls(enabled) {
  const [incoming, setIncoming] = useState([]);
  const seen = useRef(new Set());
  const stopRing = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await apiClient.get("/softphone/incoming");
        if (!alive) return;
        const rows = Array.isArray(data) ? data : [];
        setIncoming(rows);
        rows.filter((r) => !seen.current.has(r.id)).forEach((r) => {
          seen.current.add(r.id);
          if ("Notification" in window && Notification.permission === "granted" && document.hidden) {
            const n = new Notification("Incoming call — MedexOVA", { body: `${r.name}${r.phone ? ` · ${r.phone}` : ""}`, tag: r.id });
            n.onclick = () => { window.focus(); n.close(); };
          }
        });
      } catch { /* keep last state */ }
    };
    poll();
    const t = setInterval(poll, 3000);
    return () => { alive = false; clearInterval(t); };
  }, [enabled]);

  useEffect(() => {
    if (incoming.length && !stopRing.current) stopRing.current = startRingtone();
    if (!incoming.length && stopRing.current) { stopRing.current(); stopRing.current = null; }
  }, [incoming.length]);

  useEffect(() => () => stopRing.current?.(), []);

  const dismiss = (id) => setIncoming((rows) => rows.filter((r) => r.id !== id));
  return { incoming, dismiss };
}
